// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"12":"f46c0b9e","18":"231093a7","122":"f9b89eb1","135":"7ac1896b","136":"0124ef9d","312":"ab074fcd","912":"67c0f6b6","961":"733f88ae"}[chunkId] + ".chunk.js";
};